// extracted by mini-css-extract-plugin
export default {"heading5":"heading-05_heading5__0LtpG","semibold":"heading-05_semibold__ENzl-","error":"heading-05_error__dSqpD"};